import { Component, Input } from '@angular/core';
import { SharedModule } from '@shared/modules/shared.module';
import { ToastModule } from 'primeng/toast';

@Component({
	selector: 'app-toast',
	imports: [SharedModule, ToastModule],
	templateUrl: './toast.component.html',
	styleUrls: ['./toast-style1.component.scss', './toast-style2.component.scss'],
})
export class ToastComponent {
	@Input() type: '1' | '2' = '2'; // Default to style 2
	@Input() key?: string; // Allows multiple toasts with different styles
}
